// URL 객체 기반으로 한국어 매핑 생성
const getScreenNameKorean = (pathname) => {
    const screenNameMap = {
        // 메인
        "/": "메인페이지",
        "/error": "에러페이지",
        "/networkError": "네트워크 에러페이지",

        // SNS
        "/oauth/kakao/callback": "카카오 로그인 콜백",
        "/oauth/naver/callback": "네이버 로그인 콜백",
        "/oauth/google/callback": "구글 로그인 콜백",
        "/oauth/apple/callback": "애플 로그인 콜백",
        "/nice/redirect": "나이스 성공",

        // Login
        "/AllowAccess": "앱 접근 권한 허용",
        "/Landing": "랜딩 페이지",
        "/LoginMain": "아이디 로그인 페이지",
        "/Identity": "본인 확인 방법",
        "/MobileIdentity": "휴대폰 본인확인",
        "/AgreeConditions": "약관 동의",
        "/AgreeGuardian": "보호자 동의",
        "/MembershipComplete": "가입 완료",
        "/HistoryCheck": "가입 이력 확인",
        "/HospitalLink": "병원 환자번호 연동",
        "/HospitalLinkComplete": "병원 환자번호 연동 완료",
        "/SignUp": "회원 가입",
        "/FindId": "아이디 찾기",
        "/FindPassword": "비밀번호 찾기",

        // 홈케어
        "/HomeCareMain": "홈케어 메인",
        "/homeToDo": "오늘의 할일",
        "/calender": "캘린더",
        "/PillAdd": "복약추가",
        "/PillModify": "복약 기록수정",
        "/PillDetail": "복약 기록 상세",
        "/PillDetailUser": "복약 기록 상세 (사용자 지정)",
        "/PillAlarm": "복약 알림",
        "/HealthAdd": "건강기록 추가",
        "/HealthWrite": "건강 일지 수정",
        "/HealthWriteList": "건강 일지 수정 리스트",
        "/HealthDetail": "건강 기록 상세",
        "/HealthAlarm": "건강 기록 알림",
        "/EmotionAdd": "감정 일지 추가",
        "/EmotionWriteList": "감정 일지 수정 리스트",
        "/EmotionWrite": "감정 일지 수정",
        "/BloodPressureRecord": "혈압기록",
        "/BloodPressureWrite": "혈압기록하기",
        "/BloodSugarRecord": "혈당기록",
        "/BloodSugarWrite": "혈당기록하기",
        "/BodyMassRecord": "체질량 기록",
        "/BodyMassWrite": "체질량 기록하기",
        "/StepsMain": "걸음수 메인",
        "/StepsDashboard": "걸음수 기록 대시보드",
        "/StepsRecordList": "걸음수 기록 리스트",
        "/DiseaseSetting": "질환 설정",
        "/NoticeBoradMovieDetail": "동영상 게시판 상세",
        "/NoticeBoradCardDetail": "카드 게시판 상세",
        "/NoticeBoradSlideDetail": "슬라이드 게시판 상세",
        "/NoticeBoradPdfDetail": "PDF 게시판 상세",
        "/CustomHealthCardDetail": "맞춤질환 카드 상세",
        "/CustomHealthSlideDetail": "맞춤질환 슬라이드 상세",
        "/CustomHealthMovieDetail": "맞춤질환 비디오 상세",
        "/PreQuestionMain": "사전 설문지 메인",
        "/PreQuestion": "사전 설문지",

        // 설문지
        "/Survey_01": "전반적인 활동 상태 설문지",
        "/Survey_02": "동반 질환 확인 설문",
        "/Survey_03": "일상생활 동작 수행 능력 평가",
        "/Survey_04": "집안일 및 외부 활동 수행 능력 설문지",
        "/Survey_05": "기억력 및 인지기능 자가진단 설문",
        "/Survey_06": "기분 상태 및 스트레스 자가진단 설문",
        "/Survey_07": "최근 삶의 질 평가 설문",
        "/Survey_08": "숙주반응 자가 평가",
        "/Survey_09": "삶의 질 평가 설문 (종합)",
        "/Survey_10": "손발 저림 감각이상 증상 체크",
        "/Survey_11": "조혈모세포이식 환자 삶의 질 평가",
        "/Survey_15": "만성 이식합병증 증상 평가",
        "/Survey_16": "당뇨병성 신경병증 설문 (내분비내과)",
        "/Survey_17": "당뇨병 위험도 점검 (내분비내과)",
        "/Survey_18": "당뇨병성 신경병증 설문 (신장내과)",
        "/Survey_19": "당뇨병 위험도 점검 (신장내과)",
        "/Survey_20": "당뇨병성 신경병증 설문 (순환기내과)",
        "/Survey_21": "당뇨병 위험도 점검 (순환기내과)",
        "/Survey_22": "당뇨병성 신경병증 설문 (이비인후과)",
        "/Survey_23": "당뇨병 위험도 점검 (이비인후과)",
        "/Survey_24": "단백질식단 섭취 설문",
        "/Survey_25": "이명 설문",
        "/Survey_26": "이명 장애 척도 설문",
        "/Survey_27": "어지럼증 설문",
        "/Survey_28": "어지럼증 설문 2",

        "/SurveyCustom" : "설문지(맞춤) 작성",

        // 병원케어
        "/hospitalCare": "병원케어 홈",
        "/hospitalCare/MedicalHistory": "진료내역",
        "/hospitalCare/MedicalReservationHistory": "진료예약내역",
        "/hospitalCare/PrescriptionHistory": "처방내역",
        "/hospitalCare/InspectionHistory": "검사내역",
        "/hospitalCare/MedicalDetails": "진료내역 상세",
        "/hospitalCare/MedicalOutDetails": "진료내역 상세 (비대면)",
        "/hospitalCare/MedicalOutDetails/PayMedicalExpenses": "진료비 수납하기",
        "/hospitalCare/MedicalReservationDetailsIn": "진료예약 상세 (외래)",
        "/hospitalCare/MedicalReservationDetailsOut": "진료예약 상세 (비대면)",
        "/hospitalCare/MedicalReservationDetailsOut/coverPage": "비대면 진료 커버",
        "/hospitalCare/PrescriptionDetail": "처방내역 상세",
        "/hospitalCare/InspectionDetail": "검사내역 상세",
        "/hospitalCare/PrescriptionCheck": "처방전 확인하기",
        "/hospitalCare/PharmacyFind": "근처 약국 찾기",
        "/hospitalCare/HospitalInformation": "병원정보",
        "/hospitalCare/DepartmentInform": "진료과/의료진 안내",
        "/hospitalCare/DepartmentDetail": "진료과 상세",
        "/hospitalCare/DoctorDetail": "의료진 상세",
        "/hospitalCare/LocationInfo": "진료실/검사실 위치 안내",
        "/hospitalCare/PhoneNumInfo": "주요 전화번호 안내",
        "/hospitalCare/Amenity": "편의시설",
        "/hospitalCare/Directions": "오시는 길",
        "/hospitalCare/Parking": "주차안내",
        "/hospitalCare/ParentalSettings": "가족/보호자 설정",
        "/hospitalCare/ParentalRegister": "가족/보호자 등록",
        "/hospitalCare/NoticeLists": "공지사항 리스트",
        "/hospitalCare/NoticeDetail": "공지사항 상세",
        "/hospitalCare/FAQLists": "자주찾는 질문",

        // 알림
        "/Alarm": "알림 홈",

        // 내정보
        "/MyPageMain": "내정보",
        "/MyPageMain/summary": "내정보 요약",
        "/MyPageMain/detail": "내정보 상세",
        "/MyPage/MyDataCollect": "내 의료 정보 모으기",
        "/MyPage/DiagnosisMore": "주요 진단 더보기",
        "/MyPage/SurgeryMore": "주요 수술/처치력 더보기",
        "/MyPage/MedicationMore": "주요 약물 더보기",
        "/MyPage/InspectionMore": "주요 검사결과 더보기",
        "/MyPage/DoctorMore": "주치의 더보기",
        "/MyPage/MyDataViewSetting": "화면 설정",
        "/MyPage/BasicInfoWrite": "기본정보 수정",
        "/MyPage/AllergyListWrite": "알레르기 수정",
        "/MyPage/PastHistoryWrite": "과거력 수정",
        "/MyPage/FamilyHistoryWrite": "가족력 수정",
        "/MyPage/DrugsListWrite": "현재 복용중인 약물 수정",
        "/MyPage/InspectionTotalDetail": "검사 상세",

        // 전체 메뉴
        "/TotalMenu": "전체 메뉴",
        "/AppSettings": "앱 설정",
        "/MyInfoWrite": "내 정보 수정",
        "/ChangePassword": "비밀번호 변경",
        "/MyInfoWithdraw": "탈퇴하기",
        "/AppAlarmSetting": "앱 알림 설정",
        "/CustomDiseaseSetting": "맞춤 질환 정보 설정",
        "/MyHospitalSetting": "내 병원 설정",
        "/MyHospitalDisconnect": "병원 연결 해제",
        "/MyHospitalConnection": "병원 연결",
        "/MyHospitalLink": "병원 환자번호 연동",
        "/MainHospitalSetting": "대표 병원 설정",
        "/HospitalOrderSetting": "병원 순서 변경",
        "/RecordSetting": "기록설정",
        "/RecordSettingDetail": "기록 설정 세부",
        "/ServiceNotice": "서비스 공지사항",
        "/ServiceNoticeDetail": "서비스 공지사항 상세",
        "/ServiceUseGuide": "서비스 이용 가이드",
        "/ServiceUseGuideDetail": "서비스 이용 가이드 상세",
        "/ServiceFaqLists": "자주하는 질문",
        "/ServicePolicy": "서비스 약관 및 정책",
        "/ServicePolicyDetail": "서비스 약관 및 정책 상세",
        "/AppVersion": "앱 버전 정보",
        "/ErrorReport": "오류 제보",
        "/Accessibility": "고대비 설정",
        "/AppSettings/tts": "TTS 설정",
        "/BusinessInform": "사업자 정보",

        // 채팅
        "/ServiceChat": "서비스 이용 안내",
        "/NutritionChat": "영양 상담",

        // 비대면
        "/NonFaceLoginMain": "비대면 로그인",
        "/NonFaceSignUp": "비대면 회원가입",
        "/NonFaceAgreeConditions": "비대면 회원가입 약관",
        "/NonFaceFindId": "비대면 아이디 찾기",
        "/NonFaceFindPassword": "비대면 비밀번호 찾기",
        "/NonFaceChangePassword": "비대면 비밀번호 변경",
        "/NonFaceComplete": "비대면 완료",
        "/NonFaceWithdraw": "비대면 탈퇴",
        "/ContactlessMain": "비대면 상담 메인",
        "/ContactlessDetail": "비대면 상담 상세",
        "/ContactlessSetting": "비대면 설정",
        "/ContactlessEdit": "비대면 수정",
        "/ContactlessNotice": "비대면 알림게시판",
        "/HospitalLinkage": "비대면 병원연동",
        "/FileUpload": "비대면 파일 업로드",

        // 결제
        "/pay/register": "결제등록",
        "/pay/result": "결제리턴",

        // APK
        "/ApkDownload": "APK 다운로드",
    };

    // 쿼리스트링 제거하고 pathname만 비교
    const basePath = pathname.split('?')[0];

    return screenNameMap[basePath] || pathname;
};

export default getScreenNameKorean;